// extracted by mini-css-extract-plugin
export var section = "styles-module--section--Kh6Qa";
export var imageContainer = "styles-module--imageContainer--fsquD";